import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Employee } from 'src/app/shared/models/employee/employee';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})
export class EmployeeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Récupère tout les employees actifs
	 * @returns
	 */
	getAllActiveEmployees(): Observable<Employee[]> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('active', true);

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}`,
			'getAllEmployees',
			httpOptions
		);
	}

	importEmployeesFromOcashe(): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/import/ocashe`,
			'importEmployeesFromOcashe'
		);
	}

	/**
	 * Récupère tout les employees actifs avec les congés
	 * @returns
	 */
	getAllActiveEmployeesWithVacations(
		year: number,
		weekNumber: number,
		forMonth: boolean
	): Observable<Employee[]> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('active', true);
		queryParams = queryParams.append('withVacation', true);
		queryParams = queryParams.append('year', year);
		queryParams = queryParams.append('weekNumber', weekNumber);
		queryParams = queryParams.append('forMonth', forMonth);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}`,
			'getAllEmployees',
			httpOptions
		);
	}

	/**
	 * Récupère tout les employees actifs avec les congés
	 * @returns
	 */
	getAllActiveEmployeesWithVacationsForYear(
		year: number
	): Observable<Employee[]> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('active', true);
		queryParams = queryParams.append('withVacation', true);
		queryParams = queryParams.append('year', year);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}`,
			'getAllEmployees',
			httpOptions
		);
	}

	/**
	 * Récupère tout les employee qui ne sont pas absents et pas indisponibles
	 * @returns
	 */
	getAllEmployeesAvailable(
		date: Date,
		startTime: number,
		endTime: number
	): Observable<Employee[]> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('active', true);
		queryParams = queryParams.append('availabilityDate', date.getTime());
		queryParams = queryParams.append('availabilityStart', startTime);
		queryParams = queryParams.append('availabilityEnd', endTime);

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}`,
			'getAllEmployeesAvailable',
			httpOptions
		);
	}

	/**
	 * Récupère un employée en fonction de son id
	 * @param empId
	 * @returns
	 */
	getEmployeeById(empId: number): Observable<Employee> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/${empId}`,
			'getEmployeeById'
		);
	}

	getEmployeeByOcasheId(empOcasheId: number): Observable<Employee> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/ocashe/${empOcasheId}`,
			'getEmployeeByOcasheId'
		);
	}

	getEmployeeByMissionRequestId(missionRqId: number): Observable<Employee> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.employeeUrl}/missionRequest/${missionRqId}`,
			'getEmployeeByMissionRequestId'
		);
	}

	importEmployees(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'employees.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeeUrl}/import`,
			`importEmployees`,
			formData
		);
	}

	/**
	 * Met à jour un employee
	 * @param employee
	 * @returns
	 */
	updateEmployee(employee: Employee): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.employeeUrl}`,
			`updateEmployee`,
			employee
		);
	}

	/**
	 * Sauvegarde un employee
	 * @param employee
	 * @returns
	 */
	addEmployee(employee: Employee): Observable<string> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.employeeUrl}`,
			`addEmployee`,
			employee
		);
	}

	/**
	 * Supprime un employee
	 * @param empId id de l'employee
	 * @returns
	 */
	deleteEmployee(empId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.employeeUrl}/${empId}`,
			`deleteEmployee`
		);
	}
}
